<p-dialog
  [header]="'selecthorAdmin.customerList.invoiceDialog.header' | transloco"
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '650px'}"
  [closable]="true"
  data-testid="invoice-data-dialog"
>
  <ng-container>
    <form
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      class="flex flex-col gap-4"
      data-testid="admin-provider-registration-form"
    >
      <div class="grid grid-cols-2 gap-4">
        <app-form-field
          id="providerInvoiceNumber"
          fieldName="invoiceNumber"
          label="selecthorAdmin.provider.invoices.invoiceId"
          type="text"
        ></app-form-field>
        <app-form-field-select
          id="providerInvoicestatus"
          fieldName="status"
          label="selecthorAdmin.provider.invoices.status"
          [options]="invoiceStatusOptions()"
        ></app-form-field-select>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <app-form-field
          id="providerInvoiceDate"
          fieldName="invoiceDate"
          label="selecthorAdmin.provider.invoices.invoiceDate"
          type="datePicker"
        ></app-form-field>
        <app-form-field
          id="providerInvoiceDueDate"
          fieldName="dueDate"
          label="selecthorAdmin.provider.invoices.dueDate"
          type="datePicker"
        ></app-form-field>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <app-form-field
          id="providerInvoiceAmount"
          fieldName="amount"
          label="selecthorAdmin.provider.invoices.invoiceAmount"
          type="number"
        ></app-form-field>
        <app-form-field-select
          id="providerInvoiceCurrency"
          fieldName="currency"
          label="common.currency"
          [options]="currencyOptions()"
        ></app-form-field-select>
      </div>
      <div class="grid grid-cols-1 gap-4">
        <app-form-field-select
          id="providerDirectusUuid"
          fieldName="providerDirectusUuid"
          label="common.hrToolProviderDirectusId"
          [options]="providerOptions()"
        ></app-form-field-select>
      </div>
      <div class="grid grid-cols-1 gap-4">
        <div class="flex flex-col gap-2">
          <span class="truncate">{{ 'selecthorAdmin.provider.invoices.plan' | transloco }}</span>
          <p
            class="p-inputtext p-disabled border rounded-md p-2 bg-gray-50 min-h-10 flex items-center"
          >
            {{ this.selectedProviderPlan() || '&nbsp;' }}
          </p>
        </div>
      </div>
      <div class="grid grid-cols-1 gap-4">
        <app-form-field
          id="providerInvoiceDescription"
          fieldName="description"
          label="selecthorAdmin.provider.invoices.description"
          type="textarea"
        ></app-form-field>
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold">{{ 'selecthorAdmin.provider.invoices.upload' | transloco }}</span>
        <app-form-field
          id="providerInvoiceFile"
          fieldName="invoiceFile"
          label="selecthorAdmin.provider.invoices.file"
          type="file"
          accept="application/pdf"
        ></app-form-field>
        @if (selectedFile) {
          <div class="text-sm text-gray-600 italic">
            {{ 'selecthorAdmin.provider.invoices.selectedFile' | transloco }}:
            {{ selectedFile!.name }}
          </div>
        }
      </div>
    </form>
  </ng-container>

  <ng-template #footer>
    <div class="flex justify-end mt-4 gap-2">
      <p-button
        [label]="'common.close' | transloco"
        (onClick)="close()"
        severity="secondary"
        data-testid="close-invoice-dialog-btn"
      />
      <p-button
        type="submit"
        [label]="'common.save' | transloco"
        [disabled]="form.invalid"
        (onClick)="onSubmit()"
        data-testid="submit-invoice-btn"
      />
    </div>
  </ng-template>
</p-dialog>
